var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcos06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 166.8 166.8",
    style: {
      enableBackground: "new 0 0 166.8 166.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#A30039;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.3,46.7c-0.9-0.8-2.2-1.2-3.4-1.1c-1.2,0.1-2.4,0.6-3.2,1.5c-0.8,0.9-1.3,2.1-1.3,3.3v14.5H72.5 C34.6,64.9,29,84,29,95.5v19.3c0,1.1,0.4,2.1,1,3c0.7,0.9,1.6,1.5,2.7,1.7c0.4,0.1,0.7,0.1,1.1,0.1c0.9,0,1.8-0.3,2.5-0.7 s1.4-1.1,1.8-2c5.6-11.2,16.8-16.7,34.3-16.7h20.9v14.5c0,1.2,0.5,2.4,1.3,3.3s2,1.4,3.2,1.5s2.4-0.3,3.4-1.1L140,86.3l0,0 c1.1-0.9,1.7-2.3,1.7-3.7c0-1.4-0.6-2.8-1.7-3.7L101.3,46.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcos06);
export default __webpack_public_path__ + "static/media/icos-06.deeb346b.svg";
export { ForwardRef as ReactComponent };